import { graphql, useStaticQuery } from 'gatsby';
import globalState from '~/store/index';

const useCategories = () => {
  const [resourceType] = globalState('resourceType');

  const data = useStaticQuery(graphql`
    query {
      allWpCategory(filter: { name: { nin: [ "Uncategorized", "Uncategorised"] } }) {
        nodes {
          id
          slug
          name
          uri
        }
      }
    }
  `);
  const partners = [
    'industry-insights',
    'landlord-advice',
    'hosting-tips',
    'company-news',
    'podcast',
    'employee-interview',
    'research-analysis',
    'sustainability',
  ];

  const residential = [
    'company-news',
    'guest-travel-tips',
    'local-highlights',
  ];
  const filteredCategory = [];
  const cats = data?.allWpCategory?.nodes;
  cats.forEach((item) => {
    if ( item.name && item.name.toLowerCase() !== 'paris') {
      filteredCategory.push(item);
    }
  });


  if (resourceType === 'residential') {
    return filteredCategory.filter(c => residential.includes(c.slug));
  } else if (resourceType === 'partner') {
    return filteredCategory.filter(c => partners.includes(c.slug));
  } else {
    return filteredCategory;
  }
};

export default useCategories;
